import { render, staticRenderFns } from "./WsScrollableWrap001.vue?vue&type=template&id=45aacb6a"
import script from "./WsScrollableWrap001.vue?vue&type=script&lang=js"
export * from "./WsScrollableWrap001.vue?vue&type=script&lang=js"
import style0 from "./WsScrollableWrap001.vue?vue&type=style&index=0&id=45aacb6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports